// extracted by mini-css-extract-plugin
export var carousel = "homeJournal-module--carousel--MPUbZ";
export var homeJournal__container = "homeJournal-module--homeJournal__container--jpvcR";
export var home__journalDivider = "homeJournal-module--home__journalDivider--z+thd";
export var postCard = "homeJournal-module--postCard--gCq75";
export var postCardInner = "homeJournal-module--postCardInner--FgOq5";
export var slider = "homeJournal-module--slider--hLpfG";
export var testTestTest = "homeJournal-module--testTestTest--GMhMt";